import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {PopoverModule} from 'ngx-popover';
import {CollapseMenuComponent} from './collapse-menu';
import {RecentProjectsComponent} from './recent-projects';
import {FullScreenComponent} from './full-screen';
import {ActivitiesComponent} from './activities';
import {ActivitiesMessageComponent} from './activities/activities-message';
import {ActivitiesNotificationComponent} from './activities/activities-notification';
import {ActivitiesTaskComponent} from './activities/activities-task';
import {HeaderComponent} from './header.component';
import {UtilsModule} from '../../utils/utils.module';
import {I18nModule} from '../../i18n/i18n.module';
import {UserModule} from '../../user';
import {VoiceControlModule} from '../../voice-control/voice-control.module';
import {BsDropdownModule} from 'ngx-bootstrap';


@NgModule({
  imports: [
    CommonModule,

    FormsModule,

    VoiceControlModule,

    BsDropdownModule,

    UtilsModule, I18nModule, UserModule, PopoverModule,
  ],
  declarations: [
    ActivitiesMessageComponent,
    ActivitiesNotificationComponent,
    ActivitiesTaskComponent,
    RecentProjectsComponent,
    FullScreenComponent,
    CollapseMenuComponent,
    ActivitiesComponent,
    HeaderComponent,
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule {}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.module.ts